export default "/kiban/_next/static/images/21_8L_none-5d481c0d204ff9ec35214fc52a72ed3a.png";